import React from 'react'
import moment from 'moment'
import { Query } from 'react-apollo'
import { PAGE_QUERY } from './graphql'
import { isMobile } from 'frontend_core/dist/helpers/screen'
import MustHeader from 'components/organisms/MustHeader'

let bannerIndex = null

export default props => (
  <Query query={PAGE_QUERY} ssr={false}>
    {({ loading, error, data }) => {
      if (!!loading || !!error || !data) return null
      const banners = data.banners.results
      if (bannerIndex === null) {
        bannerIndex = Math.floor(Math.random() * banners.length)
      }
      const banner = data.banners.results[bannerIndex]
      return banner ? (
        <MustHeader
          isMobile={isMobile()}
          banner={banner}
          endedAt={moment(banner.endedAt).utc()}
        />
      ) : null
    }}
  </Query>
)



// WEBPACK FOOTER //
// ./src/containers/organisms/MustHeader/index.js